import React from 'react';

export const InfoAccountComponent = ({ children }) => <div className="info-compte">{children}</div>;



// WEBPACK FOOTER //
// ./src/components/pages/account/InfoAccountComponent.js